import React from 'react'
import './KovalentContent.scss'
import CallToActionBanner from '../../CallToActionBanner/CallToActionBanner'
import { Link } from '@reach/router'

export class KovalentContent extends React.Component {
  render() {
    return (
      <div className="kubernetes-content">
        <div className="light">
          <section className="padding-large ">
            <div className="row">
              <div className="col-md-12">
                <h3>Modern Data Platform for Secure Environments</h3>
                <div className="service-row">
                  <div className="text-wrap">
                    <p>
                      Leveraging AI and LLMs in disconnected or controlled
                      environments has traditionally been a challenge. Enclave
                      AI is Rackner's data platform - built on Apache Iceberg and
                      modern data engineering tools - that brings the power of
                      advanced analytics and AI to air-gapped, edge, and secure
                      environments. Whether you're in Defense, manufacturing, or
                      any industry with strict data governance requirements,
                      Enclave AI enables you to harness your data without
                      compromising security or connectivity constraints.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div className="">
          <section className="padding-large ">
            <div className="row">
              <div className="col-md-12">
                <h3>Want to learn more?</h3>
                <div className="service-row">
                  <div className="text-wrap">
                    <p>
                      If you're an organization looking to better harness data
                      and metrics across a fleet of devices, new or old - we'd
                      love to talk. Please reach out to us at{' '}
                      <b>contact@rackner.com</b> or through the form on this
                      website
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <CallToActionBanner route={'contact'} linkText={'Get in touch'} />
      </div>
    )
  }
}

export default KovalentContent
